import Vue from "../main";
import { getProductsVariantService } from "../services/productService";
import { initCartService, addProductToCartService, removeProductFromCartService, getCartService, addCartDiscountService, removeCartDiscountService, closeCartService } from "../services/cartService";

export async function addToCart(pId,vId, qty = 1) {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  //try catch is optional, adapt to your own logic
  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      let cartRes = await initCartService();
      carrelloId = cartRes.carrelloId;
      localStorage.setItem("carrelloId", carrelloId);
    }
    // Make request for product
    const res = await getProductsVariantService({"prodottoId":pId});

    if (!res || res.error) {
      throw new Error(res.message || "Error while getting product details.");
    }

    var productVariant = res.varianti.find((v) => {
        return v._id == vId
    });

    let addedRes = await addProductToCartService({
      "carrelloId": carrelloId,
      "prodottoId": pId,
      "prodottovarianteId": vId,
      "qty": qty
    });
    if (!addedRes || addedRes.error) {
      throw new Error(addedRes.message || "Error while adding product.");
    }

    let cart = await getCartService({"carrelloId": carrelloId});
    var item = cart.carrello.elementi.find((e) => {
      return e._prodotto == pId && e._prodottoVariante == vId;
    });

    item.productVariant = productVariant;

    let cartSummary = {...cart.carrello};
    delete cartSummary["elementi"]; // remove cart elements from cart object as already stored in store
    cart = {};  // clear unused cart object
    
    // add to client-side cart
    $store.dispatch("addProduct", {item, cartSummary});
    $toast.success(item.nome +" added to cart.");
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return "";
  }
}
export async function removeFromCart(cartElement) {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;
  const eId = cartElement._id;

  //try catch is optional, adapt to your own logic
  try {
    // Make request for product
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Item not found in cart.");
      return "";
    }
    let removeRes = await removeProductFromCartService({
        "carrelloId": carrelloId,
        "elementoId": eId,
        "qty": cartElement.qty
      });

    if (!removeRes || removeRes.error) {
      throw new Error(removeRes.message || "Error while removing product.");
    }
    // remove from client-side cart
    $store.dispatch("removeProduct", eId);
    $toast.success(cartElement.nome +" removed from cart.");
  } catch {
    $toast.error("An error has occurred.");
    return "";
  }
}
export async function addCartDiscount(couponCode) {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Your cart is empty.");
      return "";
    }

    var res = await addCartDiscountService({
        "carrelloId": carrelloId,
        "codiceSconto": couponCode
      }
    );
    if (!res || res.error) {
      throw new Error("Failed to apply discount, check your coupon code.");
    }
    let cartSummary = await getCartSummary();

    // update client-side cart
    $store.dispatch("updateCartSummary", cartSummary);
    $toast.success("Discount applied.");
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return "";
  }
}
export async function removeCartDiscount() {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return "";
    }

    var res = await removeCartDiscountService({
        "carrelloId": carrelloId
      }
    );
    if (!res || res.error) {
      throw new Error(res.message || "Failed to remove discount");
    }

    let cartSummary = await getCartSummary();

    // update client-side cart
    $store.dispatch("updateCartSummary", cartSummary);
    $toast.success("Discount removed.");
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return "";
  }
}

export async function closeCart() {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await closeCartService({
        "carrelloId": carrelloId
      }
    );
    if (!res || res.error) {
      throw new Error(res.message || "Failed to order.");
    }

    let {cartSummary, cartItems} = await getCartItemsAndCartSummary();
    $store.dispatch("updateCartSummary", cartSummary);
    $store.dispatch("updateAllCartItems", cartItems);
    $toast.success("Order placed successfully.");

    return {"cartSummary": cartSummary, "cartItems": cartItems};
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}

export async function getCartSummary() {
  const {
    $toast,
  } = Vue._context.config.globalProperties;
  // Check if cart is initialized
  let carrelloId = localStorage.getItem("carrelloId");
  if (!carrelloId || carrelloId === "undefined") {
    $toast.error("Cart is not initiated.");
    return false;
  }

  let cart = await getCartService({"carrelloId": carrelloId});

  let cartSummary = {...cart.carrello};
  delete cartSummary["elementi"]; // remove cart elements from cart object as already stored in store
  cart = {};  // clear unused cart object

  return cartSummary;
}

export async function getCartItemsAndCartSummary() {
  const {
    $toast,
  } = Vue._context.config.globalProperties;
  // Check if cart is initialized
  let carrelloId = localStorage.getItem("carrelloId");
  if (!carrelloId || carrelloId === "undefined") {
    $toast.error("Cart is not initiated.");
    return false;
  }

  let cart = await getCartService({"carrelloId": carrelloId});

  let cartSummary = cart.carrello;
  cart = cartSummary["elementi"];
  delete cartSummary["elementi"];
  
  return {"cartSummary": cartSummary, "cartItems": cart};
}
export async function regenerateCart() {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;
  try {
    // Check if cart is initialized
    let cartRes = await initCartService();
    if (!cartRes || cartRes.error) {
      throw new Error("Failed to initialize cart.");
    }
    let carrelloId = cartRes.carrelloId;
    localStorage.setItem("carrelloId", carrelloId);

    let {cartSummary, cartItems} = await getCartItemsAndCartSummary();
    if (!cartSummary || !cartItems) {
      throw new Error("Failed to retrieve cart.");
    }

    $store.dispatch("updateCartSummary", cartSummary);
    $store.dispatch("updateAllCartItems", cartItems);
    
    return {"cartSummary": cartSummary, "cartItems": cartItems};

  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}
